import { loadPreferences, myPreferences, savePreferences } from '@/appLogic/view/preferences';
import { isValidTableType, TableType } from '@/coreDomainsModule/table';
import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { simpleCopy } from '@/utils/deepCopy';

/**
 * ヘッダー配列をDBに保存する
 */
export class SaveTableHeaderPreferenceUseCase {
  /**
   * 列幅の配列を保存する
   * @param tableType - テーブルの種類
   * @param headerList - ヘッダーの配列
   * @returns 失敗した時はエラーを返す
   */
  public async Execute(tableType: TableType, headerList: string[]): Promise<INetworkResult<void, Error>> {
    try {
      // 最新のPreferencesを取得
      await loadPreferences();
      if (!myPreferences || !isValidTableType(tableType)) {
        console.error('myPreferencesが存在しないか、tableTypeが不正です。', tableType);
        return {
          status: {
            type: 'error',
            error: Error('保存に失敗しました'),
          },
        };
      }

      // 対象のテーブルタイプが初期化されていない場合は空のオブジェクトを設定する
      if (!myPreferences[tableType]) {
        myPreferences[tableType] = {
          tableHeaderList: [],
          hideHeaderList: [],
          columnWidths: {},
        };
      }

      const preference = simpleCopy(myPreferences[tableType]);
      preference.tableHeaderList = headerList;
      myPreferences[tableType] = preference;

      await savePreferences();
      return {
        status: {
          type: 'success',
          data: undefined,
        },
      };
    } catch (error) {
      return {
        status: {
          type: 'error',
          error: Error('取得に失敗しました'),
        },
      };
    }
  }
}
